import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import UserFeeForm from './UserFeeForm';
import TitleHeader from '../../../components/TitleHeader/TitleHeader'

class UserFee extends Component {
    render() {
        const columns = [
            { label: 'วันที่', align: 'center', name: 'date', search_type: 'string' },
            { label: 'คนไทย', align: 'left', name: 'thai', search_type: 'string' },
            { label: 'คนต่างประเทศ', align: 'left', name: 'oversea' },
        ];

        const api_url = '/master/paymentperiod';
        // const datasource = [
        //     { key: 1, active: true, value: ['01/09/2019 - 31/08/2020', 'ผู้เข้าร่วมงาน: ฿ 5,000.00<br/>ผู้ส่งผลงาน: ฿ 5,000.00', 'ผู้เข้าร่วมงาน: $ 50.00<br/>ผู้ส่งผลงาน: $ 50.00' ] },
        //     { key: 2, active: true, value: ['01/09/2018 - 31/08/2019', 'ผู้เข้าร่วมงาน: ฿ 5,000.00<br/>ผู้ส่งผลงาน: ฿ 5,000.00', 'ผู้เข้าร่วมงาน: $ 50.00<br/>ผู้ส่งผลงาน: $ 50.00' ] },
        //     { key: 3, active: true, value: ['01/09/2017 - 31/08/2018', 'ผู้เข้าร่วมงาน: ฿ 5,000.00<br/>ผู้ส่งผลงาน: ฿ 5,000.00', 'ผู้เข้าร่วมงาน: $ 50.00<br/>ผู้ส่งผลงาน: $ 50.00' ] },
        // ];

        return (
            <BrowserRouter>
                <div>
                    <TitleHeader program_name='บริหารจัดการค่าเข้างาน' program_type='ข้อมูลบัญชีผู้ใช้งาน'></TitleHeader>
                    
                    <Route exact path={`${this.props.match.path}/`} component={() => (<DataTable allow_import={false} columns={columns} allow_active={true} url={api_url}></DataTable>)} />
                    
                    <Route path={`${this.props.match.path}/create`} component={props => (<UserFeeForm {...props} url={api_url}></UserFeeForm>)} />
                    <Route path={`${this.props.match.path}/:id/edit`} component={props => (<UserFeeForm {...props} url={api_url}></UserFeeForm>)} />
                </div>
            </BrowserRouter>
        )
    }
}

export default UserFee
